/* eslint-disable import/prefer-default-export */
const currentSortColum = (path, translate) => {
  let sortColumn;
  if (path.indexOf('overview') !== -1) {
    if (path.indexOf('project') !== -1) {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'project_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'project' },
        { key: 5, text: translate('contents_header.dropdown.grade_highest'), value: 'grade' },
        { key: 6, text: translate('contents_header.dropdown.grade_lowest'), value: 'grade_r' },
        { key: 7, text: translate('contents_header.dropdown.component_largest'), value: 'component' },
        { key: 8, text: translate('contents_header.dropdown.component_lowest'), value: 'component_r' },
        { key: 9, text: translate('contents_header.dropdown.security_risk_largest'), value: 'security' },
        { key: 10, text: translate('contents_header.dropdown.security_risk_lowest'), value: 'security_r' },
        { key: 11, text: translate('contents_header.dropdown.license_largest'), value: 'license' },
        { key: 12, text: translate('contents_header.dropdown.license_lowest'), value: 'license_r' },
        { key: 13, text: translate('contents_header.dropdown.litigator_largest'), value: 'litigator' },
        { key: 14, text: translate('contents_header.dropdown.litigator_lowest'), value: 'litigator_r' },
        { key: 15, text: translate('contents_header.dropdown.violated_policy_largest'), value: 'policy' },
        { key: 16, text: translate('contents_header.dropdown.violated_policy_lowest'), value: 'policy_r' },
        { key: 17, text: translate('contents_header.dropdown.project_version_largest'), value: 'version' },
        { key: 18, text: translate('contents_header.dropdown.project_version_lowest'), value: 'version_r' },
        { key: 19, text: translate('contents_header.dropdown.project_file_largest'), value: 'file' },
        { key: 20, text: translate('contents_header.dropdown.project_file_lowest'), value: 'file_r' },
      ];
    } else {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'report_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'report' },
        { key: 5, text: translate('contents_header.dropdown.grade_highest'), value: 'grade' },
        { key: 6, text: translate('contents_header.dropdown.grade_lowest'), value: 'grade_r' },
        { key: 7, text: translate('contents_header.dropdown.component_largest'), value: 'component' },
        { key: 8, text: translate('contents_header.dropdown.component_lowest'), value: 'component_r' },
        { key: 9, text: translate('contents_header.dropdown.security_risk_largest'), value: 'security' },
        { key: 10, text: translate('contents_header.dropdown.security_risk_lowest'), value: 'security_r' },
        { key: 11, text: translate('contents_header.dropdown.license_largest'), value: 'license' },
        { key: 12, text: translate('contents_header.dropdown.license_lowest'), value: 'license_r' },
        { key: 13, text: translate('contents_header.dropdown.litigator_largest'), value: 'litigator' },
        { key: 14, text: translate('contents_header.dropdown.litigator_lowest'), value: 'litigator_r' },
        { key: 15, text: translate('contents_header.dropdown.violated_policy_largest'), value: 'policy' },
        { key: 16, text: translate('contents_header.dropdown.violated_policy_lowest'), value: 'policy_r' },
        { key: 17, text: translate('contents_header.dropdown.owner_atoz'), value: 'owner_r' },
        { key: 18, text: translate('contents_header.dropdown.owner_ztoa'), value: 'owner' },
        { key: 19, text: translate('contents_header.dropdown.scan_time_longest'), value: 'scan_time' },
        { key: 20, text: translate('contents_header.dropdown.scan_time_least'), value: 'scan_time_r' },
      ];
    }
  }
  if (path.indexOf('component') !== -1) {
    if (path.indexOf('project')) {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'project_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'project' },
        { key: 5, text: translate('contents_header.dropdown.component_largest'), value: 'component' },
        { key: 6, text: translate('contents_header.dropdown.component_lowest'), value: 'component_r' },
        {
          key: 7,
          text: translate('contents_header.dropdown.component_with_issue_largest'),
          value: 'componentwithrisk',
        },
        { key: 8, text: translate('contents_header.dropdown.project_version_largest'), value: 'version' },
        { key: 9, text: translate('contents_header.dropdown.project_version_lowest'), value: 'version_r' },
        { key: 10, text: translate('contents_header.dropdown.project_file_largest'), value: 'file' },
        { key: 11, text: translate('contents_header.dropdown.project_file_lowest'), value: 'file_r' },
        { key: 12, text: translate('contents_header.dropdown.most_found_largest'), value: 'most_found' },
        { key: 13, text: translate('contents_header.dropdown.most_found_lowest'), value: 'most_found_r' },
        { key: 14, text: translate('contents_header.dropdown.most_vulnerable_largest'), value: 'most_vulnerable' },
        { key: 15, text: translate('contents_header.dropdown.most_vulnerable_lowest'), value: 'most_vulnerable_r' },
      ];
    }
  }
  if (path.indexOf('security') !== -1) {
    if (path.indexOf('project')) {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'project_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'project' },
        { key: 5, text: translate('contents_header.dropdown.security_risk_largest'), value: 'security' },
        { key: 6, text: translate('contents_header.dropdown.security_risk_lowest'), value: 'security' },
        {
          key: 7,
          text: translate('contents_header.dropdown.critical_security_risk_largest'),
          value: 'securitycritical',
        },
        { key: 8, text: translate('contents_header.dropdown.project_version_largest'), value: 'version' },
        { key: 9, text: translate('contents_header.dropdown.project_version_lowest'), value: 'version_r' },
        { key: 10, text: translate('contents_header.dropdown.project_file_largest'), value: 'file' },
        { key: 11, text: translate('contents_header.dropdown.project_file_lowest'), value: 'file_r' },
        { key: 12, text: translate('contents_header.dropdown.most_found_largest'), value: 'most_found' },
        { key: 13, text: translate('contents_header.dropdown.most_found_lowest'), value: 'most_found_r' },
        { key: 14, text: translate('contents_header.dropdown.most_vulnerable_largest'), value: 'most_vulnerable' },
        { key: 15, text: translate('contents_header.dropdown.most_vulnerable_lowest'), value: 'most_vulnerable_r' },
      ];
    }
  }
  if (path.indexOf('license') !== -1) {
    if (path.indexOf('project')) {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'project_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'project' },
        { key: 5, text: translate('contents_header.dropdown.license_largest'), value: 'license' },
        { key: 6, text: translate('contents_header.dropdown.license_lowest'), value: 'license_r' },
        {
          key: 7,
          text: translate('contents_header.dropdown.protective_license_largest'),
          value: 'licenseprotective',
        },
        { key: 8, text: translate('contents_header.dropdown.litigator_largest'), value: 'litigator' },
        { key: 9, text: translate('contents_header.dropdown.litigator_lowest'), value: 'litigator_r' },
        { key: 10, text: translate('contents_header.dropdown.project_version_largest'), value: 'version' },
        { key: 11, text: translate('contents_header.dropdown.project_version_lowest'), value: 'version_r' },
        { key: 12, text: translate('contents_header.dropdown.project_file_largest'), value: 'file' },
        { key: 13, text: translate('contents_header.dropdown.project_file_lowest'), value: 'file_r' },
      ];
    }
  }
  if (path.indexOf('policy') !== -1) {
    if (path.indexOf('project')) {
      sortColumn = [
        { key: 1, text: translate('contents_header.dropdown.newest'), value: 'uploaded' },
        { key: 2, text: translate('contents_header.dropdown.oldest'), value: 'uploaded_r' },
        { key: 3, text: translate('contents_header.dropdown.atoz'), value: 'project_r' },
        { key: 4, text: translate('contents_header.dropdown.ztoa'), value: 'project' },
        {
          key: 5,
          text: translate('contents_header.dropdown.violated_policy_largest'),
          value: 'policy',
        },
        {
          key: 6,
          text: translate('contents_header.dropdown.violated_policy_lowest'),
          value: 'policy_r',
        },
        {
          key: 7,
          text: translate('contents_header.dropdown.policy_component_largest'),
          value: 'policy_component',
        },
        {
          key: 8,
          text: translate('contents_header.dropdown.policy_component_lowest'),
          value: 'policy_component_r',
        },
        {
          key: 9,
          text: translate('contents_header.dropdown.policy_security_largest'),
          value: 'policy_security',
        },
        {
          key: 10,
          text: translate('contents_header.dropdown.policy_security_lowest'),
          value: 'policy_security_r',
        },
        {
          key: 11,
          text: translate('contents_header.dropdown.policy_license_largest'),
          value: 'policy_license',
        },
        {
          key: 12,
          text: translate('contents_header.dropdown.policy_license_lowest'),
          value: 'policy_license_r',
        },
        {
          key: 13,
          text: translate('contents_header.dropdown.policy_litigator_largest'),
          value: 'policy_litigator',
        },
        {
          key: 14,
          text: translate('contents_header.dropdown.policy_litigator_lowest'),
          value: 'policy_litigator_r',
        },
        { key: 15, text: translate('contents_header.dropdown.project_version_largest'), value: 'version' },
        { key: 16, text: translate('contents_header.dropdown.project_version_lowest'), value: 'version_r' },
        { key: 17, text: translate('contents_header.dropdown.project_file_largest'), value: 'file' },
        { key: 18, text: translate('contents_header.dropdown.project_file_lowest'), value: 'file_r' },
      ];
    }
  }
  return sortColumn;
};

export {
  currentSortColum,
};
